module.exports = __webpack_public_path__ + "media/assets/img/video/encodage-img-67740867766cbb68717cbc9f7ed9d39e.svg";